import { render } from "./brand_list.vue?vue&type=template&id=7c19cc0c"
import script from "./brand_list.vue?vue&type=script&lang=js"
export * from "./brand_list.vue?vue&type=script&lang=js"

import "./brand_list.vue?vue&type=style&index=0&id=7c19cc0c&scope=true&lang=css"

import exportComponent from "C:\\Sunshine\\code\\zydt\\独立部署版\\ywym\\ydd-zht-api\\h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__